import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { campaignUnsubscribe } from './actions';
import CampaignUnsubscribe from './components/CampaignUnsubscribe';

const CampaignUnsubscribeContainer = compose(
  withRouter,
  withState('phone', 'setPhone', ''),
  connect(
    (state, ownProps) => ({
      isFetching: state.confirmation.get('isFetching'),
      errorMessage: state.confirmation.get('errorMessage'),
      successMessage: state.confirmation.get('successMessage'),
      ownerType: ownProps.params.ownerType,
      ownerId: ownProps.params.ownerId,
      customerId: ownProps.params.customerId,
    }),
    { campaignUnsubscribe }
  ),
  withHandlers({
    onSubmit: props => (e) => {
      e.preventDefault();
      return props.campaignUnsubscribe(props.ownerType, props.ownerId, props.phone);
    },
    setPhoneValue: ({ setPhone }) => value => setPhone(value),
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.customerId) {
        this.props.campaignUnsubscribe(this.props.ownerType, this.props.ownerId, this.props.customerId);
      }
    },
  })
)(CampaignUnsubscribe);

export default CampaignUnsubscribeContainer;



// WEBPACK FOOTER //
// ./src/app/confirmation/CampaignUnsubscribe.jsx